import { ApiError } from "@/lib/api";

/**
 * A problem set PDF's refusal, for every surface that asks for one (`EX-PDF02`
 * the organizer console, `EX-PDF03` Author Studio; `docs/07` "The problem set
 * on paper").
 */

/** Which sentence a refusal is said in, and what goes into it. */
export type PdfRefusal =
  | { key: "busy"; seconds: number }
  | { key: "unavailable" }
  | { key: "rateLimited" }
  | { key: "noProblems" }
  | { key: "denied" }
  | { key: "notFound" }
  | { key: "failed" };

/**
 * A refusal in words (`docs/07`): the busy printer says how long to wait
 * (`details.retryAfterSeconds`, 15 today), a renderer that is down says so, a
 * problem the reader can no longer print (the author set's whole-set 404, a
 * letter gone from the round) says so, and anything else is a plain failure
 * with a retry.
 */
export function pdfRefusalOf(error: unknown): PdfRefusal {
  if (!(error instanceof ApiError)) return { key: "failed" };
  if (error.code === "PROBLEM_SET_BUSY") {
    const details = error.details as { retryAfterSeconds?: unknown } | undefined;
    const seconds = typeof details?.retryAfterSeconds === "number" ? details.retryAfterSeconds : 15;
    return { key: "busy", seconds };
  }
  if (error.code === "PROBLEM_SET_UNAVAILABLE") return { key: "unavailable" };
  if (error.status === 429) return { key: "rateLimited" };
  if (error.status === 409) return { key: "noProblems" };
  if (error.status === 403) return { key: "denied" };
  if (error.status === 404) return { key: "notFound" };
  return { key: "failed" };
}
